export default "<div id=\"error\">\r\n  <div mat-dialog-content>\r\n    <h5><mat-icon>error</mat-icon>   {{ data.message }}</h5>\r\n  </div>\r\n</div>\r\n";